import { render, staticRenderFns } from "./PageAdminKeywords.vue?vue&type=template&id=38428f96"
import script from "./PageAdminKeywords.vue?vue&type=script&lang=js"
export * from "./PageAdminKeywords.vue?vue&type=script&lang=js"
import style0 from "./PageAdminKeywords.vue?vue&type=style&index=0&id=38428f96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports